import { useState, useEffect } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import H5 from 'UIComponents/elements/headings/H5';
import H2 from 'UIComponents/elements/headings/H2';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import { isFilterEmpty } from 'automation-ui-flow-core/enrollment/enrollmentUtils';
import WorkflowTypeSelect from 'automation-ui-enrollment/components/workflowType/WorkflowTypeSelect';
import { applyListTriggersToFlow } from 'automation-ui-canvas/create/utils/applyTriggers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EMPTY_FILTER_BRANCH = {
  filterBranches: [],
  filterBranchOperator: 'OR',
  filterBranchType: 'OR',
  filters: []
};
export default function ListTriggerStep({
  objectTypeId,
  setObjectTypeId,
  flow,
  setFlow,
  setValidationMessage
}) {
  var _flow$associatedLists, _flow$associatedLists2;
  const filterBranch = (_flow$associatedLists = (_flow$associatedLists2 = flow.associatedLists.find(list => list.listTypes.includes('ENROLLMENT_LIST'))) === null || _flow$associatedLists2 === void 0 ? void 0 : _flow$associatedLists2.filterBranch) !== null && _flow$associatedLists !== void 0 ? _flow$associatedLists : EMPTY_FILTER_BRANCH;
  const [stagedObjectTypeId, setStagedObjectTypeId] = useState();
  const [areFiltersIncomplete, setAreFiltersIncomplete] = useState(false);
  const handleCloseModal = () => {
    setStagedObjectTypeId(undefined);
  };
  const handleConfirmObjectTypeIdChange = () => {
    setObjectTypeId(stagedObjectTypeId !== null && stagedObjectTypeId !== void 0 ? stagedObjectTypeId : UNKNOWN_ID);
    setStagedObjectTypeId(undefined);
    setFlow(draftFlow => {
      applyListTriggersToFlow(EMPTY_FILTER_BRANCH, draftFlow);
    });
  };
  const handleObjectTypeIdChange = newObjectTypeId => {
    if (!isFilterEmpty(filterBranch)) {
      setStagedObjectTypeId(newObjectTypeId);
    } else {
      setObjectTypeId(newObjectTypeId);
    }
  };
  const handleFilterChange = newFilterBranch => {
    setFlow(draftFlow => {
      applyListTriggersToFlow(newFilterBranch, draftFlow);
    });
  };
  const handleFilterInfoChange = ({
    hasIncompleteFilters = false,
    hasFilterValidationErrors = false
  }) => {
    setAreFiltersIncomplete(hasIncompleteFilters || hasFilterValidationErrors);
  };
  const isEditingFilters = areFiltersIncomplete || isFilterEmpty(filterBranch);
  useEffect(() => {
    if (objectTypeId === UNKNOWN_ID) {
      setValidationMessage(I18n.text('createWorkflow.selectRequiredObjectTypeTooltip'));
    } else if (isEditingFilters) {
      setValidationMessage(I18n.text('automation-ui-enrollment.redesign.saveButton.tooltip.editingFilters'));
    } else {
      setValidationMessage(null);
    }
  }, [isEditingFilters, objectTypeId, setValidationMessage]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [stagedObjectTypeId && /*#__PURE__*/_jsxs(UIModal, {
      width: 550,
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: handleCloseModal
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "createWorkflow.filterCriteriaChangeObjectModal.title"
          })
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "createWorkflow.filterCriteriaChangeObjectModal.body"
        })
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          type: "submit",
          onClick: handleConfirmObjectTypeIdChange,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "createWorkflow.filterCriteriaChangeObjectModal.confirmButton"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          onClick: handleCloseModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "createWorkflow.filterCriteriaChangeObjectModal.cancelButton"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createWorkflow.filterCriteriaHeader"
      })
    }), /*#__PURE__*/_jsx(WorkflowTypeSelect, {
      objectTypeId: objectTypeId,
      onChange: handleObjectTypeIdChange,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createWorkflow.objectSelectPlaceholder"
      })
    }), objectTypeId !== UNKNOWN_ID && /*#__PURE__*/_jsx("div", {
      className: "m-y-4",
      children: /*#__PURE__*/_jsx(ListSegmentationFilters, {
        value: filterBranch,
        objectTypeId: objectTypeId,
        openInEditMode: true,
        readOnly: false,
        onFilterInfoChange: handleFilterInfoChange,
        onChange: handleFilterChange
      }, objectTypeId)
    })]
  });
}
export const listTriggerStep = {
  component: ListTriggerStep,
  getLabel: () => I18n.text('createWorkflow.step.eligibility')
};